import React from "react";
import {usePage, router, Link} from "@inertiajs/react";
import {Container, Table, Button} from "react-bootstrap";
import NoNewsletterBanner from "../../../Components/Campaigns/NoNewsletterBanner.jsx";

/**
 * Liste der wiederverwendbaren Signatur-Vorlagen für E-Mail-Kampagnen.
 */
export default function Index() {
    const {signatures} = usePage().props;

    const handleDelete = (signature) => {
        if (!window.confirm(`Signatur "${signature.name}" wirklich löschen?`)) {
            return;
        }
        router.delete(`/campaigns/signatures/${signature.id}`);
    };

    return (
        <Container fluid className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h1>Signatur-Vorlagen</h1>
                <div className="d-flex gap-2">
                    <Link href="/campaigns" className="btn btn-outline-secondary">Zurück zu Kampagnen</Link>
                    <Link href="/campaigns/signatures/create" className="btn btn-primary">Neue Signatur</Link>
                </div>
            </div>
            <NoNewsletterBanner/>
            <Table striped bordered hover className="mt-3">
                <thead>
                <tr>
                    <th>Name</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {(signatures ?? []).length === 0 && (
                    <tr>
                        <td colSpan={2} className="text-center text-muted">Noch keine Signaturen angelegt.</td>
                    </tr>
                )}
                {(signatures ?? []).map((signature) => (
                    <tr key={signature.id}>
                        <td>{signature.name}</td>
                        <td className="text-end d-flex gap-2 justify-content-end">
                            <Link href={`/campaigns/signatures/${signature.id}/edit`}
                                  className="btn btn-sm btn-outline-primary">
                                Bearbeiten
                            </Link>
                            <Button size="sm" variant="outline-danger" onClick={() => handleDelete(signature)}>
                                Löschen
                            </Button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
        </Container>
    );
}
